import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import CmsGallerySection from "../components/CmsGallerySection";
import { COMPANY, GORDON_PARTNERSHIP_DELIVERIES, DRIVER_QUALIFICATIONS } from "../data/siteData";
import { imageUrl } from "../lib/images";

export default function TransportpartnerPage() {
  return (
    <div className="bg-[#070d18] text-slate-100 min-h-screen">
      <SEOHead
        title="Transportpartner"
        description="Fast transportunderleverandør for distributionsvirksomheder og logistikoperatører med dedikeret materiel og pålidelig kapacitet."
      />

      {/* Hero Header */}
      <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 border-b border-slate-800 bg-[#081222] overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#0F766E]/20 border border-[#2DD4BF]/40 text-[#2DD4BF] text-xs font-mono uppercase tracking-widest">
              <i className="fa-solid fa-handshake text-[10px]" aria-hidden="true" />
              <span>B2B Samarbejde · Underleverandør</span>
            </div>

            <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight leading-tight font-display">
              Fast transportpartner og pålidelig underleverandør
            </h1>

            <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
              KVC Express ApS stiller moderne L2H2 kølebiler og godkendte chauffører til rådighed for logistikoperatører, distributionshuse og virksomheder. Vi leverer i hele Danmark – inklusive Bornholm.
            </p>

            <div className="pt-2 flex flex-wrap gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-[#0F766E] hover:bg-[#115E59] active:bg-[#134E4A] text-white font-bold text-xs uppercase tracking-wider transition shadow-lg shadow-[#0F766E]/30 cursor-pointer"
              >
                <span>Drøft et fast samarbejde</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-slate-900 border border-slate-700 text-slate-200 hover:text-white font-semibold text-xs transition whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-[#2DD4BF]" aria-hidden="true" />
                <span className="whitespace-nowrap">Ring: {COMPANY.phone}</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Underleverandør Context & Capabilities */}
      <section className="py-20 bg-slate-50 text-slate-900 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Content */}
            <div className="lg:col-span-6 space-y-6">
              <div className="text-xs font-mono uppercase tracking-widest text-[#0F766E] font-bold">
                Kapacitet og relationer
              </div>
              <h2 className="text-2xl sm:text-4xl font-extrabold text-slate-950 tracking-tight font-display">
                Fleksibel underleverandørkapacitet til jeres distributionsnet
              </h2>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                Større distributions- og logistikvirksomheder har brug for samarbejdspartnere, de kan regne med dag efter dag. Med dokumenteret erfaring som underleverandør i distributionssektoren (herunder i tæt samarbejde med aktører som Gordon Delivery) forstår vi kravene til præcision, sporbarhed og temperaturdisciplin.
              </p>
              <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                Vores chauffører besidder lovpligtigt chaufføruddannelsesbevis til godskørsel med varebil samt kurser i håndtering af kølevarer og medicin. Vores flåde består af nye diesel- og elbiler med aktiv temperaturkontrol.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
                <div className="p-4 rounded-xl bg-white border border-slate-200/90 shadow-sm">
                  <div className="text-[#0F766E] font-bold text-sm mb-1 flex items-center gap-2">
                    <i className="fa-solid fa-truck-ramp-box text-[#0F766E]" aria-hidden="true" />
                    <span>Stabil Kapacitet</span>
                  </div>
                  <div className="text-xs text-slate-600 leading-relaxed">
                    Moderne kølevogne mindsker nedbrud og sikrer uafbrudt kørsel på jeres faste ruter.
                  </div>
                </div>
                <div className="p-4 rounded-xl bg-white border border-slate-200/90 shadow-sm">
                  <div className="text-[#0F766E] font-bold text-sm mb-1 flex items-center gap-2">
                    <i className="fa-solid fa-id-card-clip text-[#0F766E]" aria-hidden="true" />
                    <span>Uddannede Chauffører</span>
                  </div>
                  <div className="text-xs text-slate-600 leading-relaxed">
                    Chaufføruddannelsesbevis samt specifikke kurser i kølekæde og medicinalgods.
                  </div>
                </div>
                <div className="p-4 rounded-xl bg-white border border-slate-200/90 shadow-sm">
                  <div className="text-[#0F766E] font-bold text-sm mb-1 flex items-center gap-2">
                    <i className="fa-solid fa-map-location-dot text-[#0F766E]" aria-hidden="true" />
                    <span>Hele Danmark Inkl. Bornholm</span>
                  </div>
                  <div className="text-xs text-slate-600 leading-relaxed">
                    Landsdækkende ruter – vi dækker både fastland og Bornholm.
                  </div>
                </div>
                <div className="p-4 rounded-xl bg-white border border-slate-200/90 shadow-sm">
                  <div className="text-[#0F766E] font-bold text-sm mb-1 flex items-center gap-2">
                    <i className="fa-solid fa-charging-station text-[#0F766E]" aria-hidden="true" />
                    <span>Nye Diesel- og Elbiler</span>
                  </div>
                  <div className="text-xs text-slate-600 leading-relaxed">
                    Fleksibel kapacitet med nye diesel- og elbiler tilpasset faste ruter.
                  </div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="lg:col-span-6">
              <div className="rounded-2xl overflow-hidden border border-slate-300 bg-white shadow-xl">
                <img
                  src={imageUrl("/_assets/shutterstock-2042952230.jpg", "width=900,quality=85,format=auto")}
                  alt="KVC Express hvid varevogn lastet ved moderne distributionscenter og lagerterminal"
                  className="w-full h-80 sm:h-[450px] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Leverancetyper & Partnerskabserfaring (Gordon Delivery m.fl.) */}
      <section className="py-20 bg-[#081224] border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#0F766E]/20 border border-[#2DD4BF]/40 text-[#2DD4BF] text-xs font-mono uppercase tracking-widest">
              <i className="fa-solid fa-boxes-packing text-[10px]" aria-hidden="true" />
              <span>Dokumenteret Erfaring</span>
            </div>
            <h2 className="text-2xl sm:text-4xl font-extrabold text-white tracking-tight font-display">
              Hvilke typer leverancer udfører vi?
            </h2>
            <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
              Gennem vores samarbejde med stærke logistikaktører som bl.a. <strong>Gordon Delivery</strong> og andre etablerede distributionsnetværk håndterer vi dagligt specialiserede temperaturstyrede varer med høj præcision:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
            {GORDON_PARTNERSHIP_DELIVERIES.map((item, idx) => (
              <div
                key={idx}
                className="p-7 rounded-2xl bg-[#0b162b] border border-slate-800 hover:border-[#2DD4BF]/40 transition space-y-3 relative group"
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-bold text-white group-hover:text-[#2DD4BF] transition font-display">
                    {item.category}
                  </h3>
                  <span className="text-[11px] font-mono text-[#2DD4BF] bg-[#0F766E]/20 px-2.5 py-1 rounded border border-[#0F766E]/50">
                    Aktiv Køl
                  </span>
                </div>
                <div className="text-xs font-mono text-teal-300 font-medium">
                  Eksempler: {item.examples}
                </div>
                <p className="text-sm text-slate-300 leading-relaxed pt-1">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Elbil & Bykørsel Showcase */}
          <div className="mb-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center bg-[#0b1426] p-8 rounded-2xl border border-slate-800">
            <div className="lg:col-span-6 space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#0F766E]/20 text-[#2DD4BF] text-xs font-mono uppercase tracking-wider">
                <i className="fa-solid fa-bolt text-[11px]" aria-hidden="true" />
                <span>Grøn & Støjsvag Distribution</span>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white font-display">
                Elbiler til bymiljøer og emissionsfølsomme zoner
              </h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                Vores vognpark omfatter både nye diesel- og elbiler med aktiv køl. De elektriske varebiler muliggør emissionsfri, præcis og støjsvag fremførsel i tætbefolkede byområder, miljøzoner og på faste distributionsruter.
              </p>
            </div>
            <div className="lg:col-span-6 rounded-xl overflow-hidden border border-slate-700 shadow-xl">
              <img
                src={imageUrl("/_assets/gordon-elfordon425-3.jpg", "width=800,quality=80,format=auto")}
                alt="KVC Express elektrisk kassevogn i bymiljø"
                className="w-full h-56 sm:h-64 object-cover"
              />
            </div>
          </div>

          {/* Chaufførkvalifikationer & Landsdækkende Dækning Banner */}
          <div className="p-8 sm:p-10 rounded-2xl bg-gradient-to-r from-[#072422] to-[#0a1b38] border border-[#2DD4BF]/30 shadow-2xl">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-8 space-y-4">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0F766E] text-white text-xs font-mono font-bold uppercase tracking-wider">
                  <i className="fa-solid fa-user-check text-[11px] text-[#2DD4BF]" aria-hidden="true" />
                  <span>Chauffører & Uddannelsesbeviser</span>
                </div>
                <h3 className="text-2xl font-bold text-white font-display">
                  Varebilschaufføruddannelse & kurser i køl og medicin
                </h3>
                <p className="text-slate-200 text-sm leading-relaxed">
                  Det er afgørende for os, at vores chauffører altid repræsenterer jeres brand med højeste faglighed. Alle chauffører hos KVC Express ApS opfylder Færdselsstyrelsens krav til godskørsel med varebil og besidder gyldigt chaufføruddannelsesbevis samt kurser i transport af kølevarer og medicin.
                </p>
                <div className="flex flex-wrap gap-4 pt-2 text-xs text-teal-200 font-mono">
                  <span className="flex items-center gap-1.5">
                    <i className="fa-solid fa-check text-[#2DD4BF]" aria-hidden="true" />
                    Chaufføruddannelsesbevis
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="fa-solid fa-check text-[#2DD4BF]" aria-hidden="true" />
                    Kølekædekontrol
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="fa-solid fa-check text-[#2DD4BF]" aria-hidden="true" />
                    Medicinhåndtering
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="fa-solid fa-check text-[#2DD4BF]" aria-hidden="true" />
                    Hele Danmark (inkl. Bornholm)
                  </span>
                </div>
              </div>
              <div className="lg:col-span-4 flex flex-col gap-3">
                <Link
                  to="/kontakt"
                  className="w-full text-center py-3.5 px-6 rounded-xl bg-[#0F766E] hover:bg-[#115E59] active:bg-[#134E4A] text-white font-bold text-xs uppercase tracking-wider transition shadow-lg shadow-[#0F766E]/40"
                >
                  Kontakt os om samarbejde
                </Link>
                <Link
                  to="/vores-koeretoejer"
                  className="w-full text-center py-3.5 px-6 rounded-xl bg-slate-900/80 border border-slate-700 text-slate-200 hover:text-white font-semibold text-xs transition"
                >
                  Se vognpark & materiel
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <CmsGallerySection
        gallerySlug="koeretoejer"
        title="Kapacitet & vognpark"
        subtitle="Se vores moderne flåde af L2H2 kølevogne klar til faste opgaver"
      />

      {/* Bottom CTA Block */}
      <section className="py-16 bg-[#050a14] border-t border-slate-800 text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <h3 className="text-2xl sm:text-3xl font-bold text-white font-display">
            Mangler I stabil underleverandørkapacitet til jeres ruter?
          </h3>
          <p className="text-slate-300 text-sm sm:text-base max-w-xl mx-auto">
            Kontakt KVC Express ApS for en fortrolig samtale om et langsigtet underleverandørsamarbejde.
          </p>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl bg-[#0F766E] hover:bg-[#115E59] text-white font-bold text-xs uppercase tracking-wider transition shadow-xl shadow-[#0F766E]/40"
          >
            <span>Drøft et fast samarbejde</span>
            <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
          </Link>
        </div>
      </section>
    </div>
  );
}
